import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./component/AnalyticsInit.ts";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

import TeamLanding from './component/TeamLanding';
new TeamLanding({
	team: '.teamListing',
	styleClass: {
		items: '.teamListing__item',
		links: '.teamMember__fullLink',
		bios: '.teamListing__bio'
	}
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();

import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();




// Smooth scroll to the Thank You message after successful JotForm Submission.
document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('message', function(event) {
        try {
            var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

            if (data.action === 'submission-completed') {
                var iframe = document.getElementById(data.formID);

                if (iframe) {
                    iframe.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }
        } catch (e) {
            console.error('An error occurred while processing the form response:', e);
        }
    });
});